import { AeoPromptTopicSchema } from "@redotech/redo-model/aeo/prompt";
import * as z from "zod";

export const getAeoPromptTopics = {
  name: "getAeoPromptTopics" as const,
  input: z.object({}),
  output: z.object({
    topics: z.array(AeoPromptTopicSchema.extend({ promptCount: z.number() })),
  }),
};
